module.exports = require('./src/index')



// WEBPACK FOOTER //
// ./lib/http-memoizr/index.js